import React, { useEffect, useState } from "react";
import { TextSwitch } from "../../../../../components/TextSwitch/TextSwitch";
import {
  CERTIFICATIONS_LABEL,
  COURSES_LABEL,
} from "../../../../../constants/Dictionary";
import { FormationTypeEnum } from "../../../../../constants/AppConstants";
import { CollaboratorCertifications } from "./CollaboratorCertifications/CollaboratorCertifications";
import { CollaboratorCourses } from "./CollaboratorCourses/CollaboratorCourses";
import { CmSheetSectionProps } from "../SchedaCM";

export const FormationCM = ({
  setHeaderTextSwitch,
  ...props
}: CmSheetSectionProps) => {
  const filters = [
    { value: FormationTypeEnum.COURSE, label: COURSES_LABEL },
    { value: FormationTypeEnum.CERTIFICATION, label: CERTIFICATIONS_LABEL },
  ];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  useEffect(() => {
    setHeaderTextSwitch(
      <TextSwitch
        selectedOption={selectedFilter}
        setSelectedOption={setSelectedFilter}
        options={filters}
      />,
    );
  }, [selectedFilter]);

  return (
    <>
      {selectedFilter.value === FormationTypeEnum.COURSE ? (
        <CollaboratorCourses
          {...props}
          setHeaderTextSwitch={setHeaderTextSwitch}
        />
      ) : (
        <CollaboratorCertifications
          {...props}
          setHeaderTextSwitch={setHeaderTextSwitch}
        />
      )}
    </>
  );
};
